import { render } from "./ClientDeleteDialog.vue?vue&type=template&id=568de908"
import script from "./ClientDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ClientDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__